import IState from '@/interfaces/IState';
import {ActionContext} from 'vuex';

export default async (context: ActionContext<IState, IState>, signRelationshipId: string) => {
    if (!signRelationshipId) {
        return Promise.reject('Incorrect sign relationship id');
    }
    try {
        const signRelationship = await context.dispatch('backendTalker', {
            request: 'signRelationshipDetail',
            id: signRelationshipId
        });
        if (!signRelationship) {
            return Promise.reject('Incorrect sign relationship data from backend');
        }
        return signRelationship.data;
    } catch (err) {
        return Promise.reject(err);
    }
};
